import { get } from "react-hook-form";
import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    // Ensure data is an object
    const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
    jsonData.subTenantDTO = { id: decodedToken.subTenantId };
    return jsonData; // Always return object
  }
  return data;
};

// helper: construct headers dynamically
const constructHeaders = (extraHeaders = {}) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") &&
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  // merge additional headers passed at call time
  return { ...headers, ...extraHeaders };
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

const UserApi = {
  // Login Api
  login: (data) => {
    return apiApp.post(`/user/login`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // Register Api
  register: (data) => {
    return apiApp.post(`/user/register`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // Reset Password Api
  resetPassword: (data) => {
    return apiApp.post(`/user/resetPassword`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  requestAptitudeTest: (data) => {
    return apiApp.post(`/user/requestAptitudeTest`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  resetPasswordToken: (token, data) => {
    return apiApp.post(`/user/reset/password?token=${token}`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  tokenVerification: (token) => {
    return apiApp.get(`/user/tokenVerification?token=${token}`)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  changePassword: (data) => {
    return apiApp.post(`/user/changePassword`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  updateAptitudeTestStatus: (data) => {
    return apiApp.patch(`/user/updateAptitudeTestStatus`, data)
      .then(res => res)
      .catch(err => Promise.reject(err));
  },

  verifyRegistration: (token) => {
    return apiApp.get(`/user/verifyRegistration?token=${token}`)
      .then(res => res)
      .catch(err => Promise.reject(err));
  },

  resendVerifyToken: (email) => {
    return apiApp.get(`/user/resendVerifyToken?email=${email}`)
      .then(res => res)
      .catch(err => Promise.reject(err));
  },

  sendAptitudeTest: (data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();
    return apiApp.post(`/user/sendAptitudeTest`, data, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  sendAptitudeTestSubtenets: (data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();
    return apiApp.post(`/user/sendAptitudeTest`, data, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  AddNewUser: (data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();
    return apiApp.post(`/user/register`, data, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  tenantUsers: (UsertenantId, page, limit) => {
    // data = injectSubTenantId(data);
    const headers = constructHeaders();

    return apiApp.get(`/tenant/${UsertenantId}`, { headers })
      .then((res) => {
        const tenantsApikey = res.data.payload?.tenantApiKey;
        if (!tenantsApikey) throw new Error("Tenant not found");

        const updatedHeaders = {
          Authorization: `Bearer ${token}`,
          "x-Authorization": `${tenantsApikey}`,
        };

        if (
          decodedToken?.roles?.includes("TENANT_ADMIN") ||
          decodedToken?.subTenantId === undefined
        ) {
          headers["tenant-login"] = true;
        }

        return apiApp.get(
          `/tenantusers?page=${page}&size=${limit}&sort=desc&tenantId=${UsertenantId}${getSubTenantIdParam()}`,
          { headers: updatedHeaders }
        ).then(res => res.data);
      })
      .catch(err => Promise.reject(err.response?.data || err));
  },

  tenantUnterUsers: (UsertenantId) => {
    const subTenantId = decodedToken?.subTenantId !== undefined ? decodedToken?.subTenantId : UsertenantId;
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
    };
    return apiApp.get(
      `/tenantSubtenantUsers/${subTenantId}?size=100&tenantId=${decodedToken?.tenantId}&subTenantId=${subTenantId}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  changeAccountPassword: (data) => {
    return apiApp.post(`/user/changePassword`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  ProtectiveClothing: (data) => {
    return apiApp.post(`/protectiveCloths`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserHealthAnswer: (userEmail) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
    };
    return apiApp.get(`/questionSetsAnswer?email=${userEmail}`, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  DeleteUsers: (UserId) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
    };
    return apiApp.delete(
      `/user/manage/${UserId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserProfile: () => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
    };
    return apiApp.get(
      `/user-profile/file-resources?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserProfileDelete: (ProfileId) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
    };
    return apiApp.delete(
      `/user-profile/file-resources/${ProfileId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserDetails: () => {
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   "x-Authorization": decodedToken?.tenantApiKey,
    //   email: decodedToken?.sub,
    // };
    const headers = constructHeaders({ "email": decodedToken?.sub });
    return apiApp.get(
      `/user?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserNotification: () => {
    const headers = constructHeaders();
    return apiApp.get(
      `/alerts/count-not-read?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  TenantUserDetails: (Email) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
      email: Email,
    };
    return apiApp.get(
      `/user?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserDetailsUpdate: async (userID, data) => {
    try {
      const payload = injectSubTenantId(data);
      const headers = constructHeaders();
      const res = await apiApp.put(`/user/${userID}`, payload, { headers });
      return res.data;
    } catch (err) {
      // Handle missing response safely
      throw err.response?.data || err.message || 'Unknown error occurred';
    }
  },

  CreateTenantAdmin: (data) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": decodedToken?.tenantApiKey,
      "Content-Type": "application/json",
    };
    return apiApp.post(`/user/register`, data, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  GetOnboarderdUsers: (page, limit) => {
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   "x-Authorization": decodedToken?.tenantApiKey,
    // };
    const headers = constructHeaders();
    return apiApp.get(
      `/user/onboard?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  UserByEmail: (email) => {
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   "x-Authorization": decodedToken?.tenantApiKey,
    // };
    return apiApp.get(`/user?email=${email}`)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  AssignLoginCode: (userId, data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();
    return apiApp.patch(`/user/${userId}/assign-user-id`, data, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  loginWithCode: (data) => {
    return apiApp.post(`/user/login-by-userid`, data)
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },
};

export default UserApi;
